import { apiPrisma } from '../../api';

class FinancialStatus {
  async getStatus() {
    return apiPrisma.get('/api/financeiro/status');
  }
}

export default new FinancialStatus();
